import ADataTableColumn from './index.vue';

ADataTableColumn.install = app => {
  app.component(ADataTableColumn.name, ADataTableColumn);
};

export default ADataTableColumn;
